import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import {
  isErrorUserPendingApproval,
  isForbiddenError,
  storableError,
} from '../../util/errors';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { parse } from '../../util/urlHelpers';
import {  transactionLineItems } from '../../util/api';
import { types as sdkTypes } from '../../util/sdkLoader';
const SET_SELECTED = 'app/VoucherPurchasePage/SET_SELECTED';
const SET_FORM = 'app/VoucherPurchasePage/SET_FORM';
const PURCHASE_VOUCHER_SUCCESS =
  'app/VoucherPurchasePage/PURCHASE_VOUCHER_SUCCESS';

export const GET_GIFTCARDS_REQUEST =
  'app/VoucherPurchasePage/GET_GIFTCARDS_REQUEST';
export const GET_GIFTCARDS_SUCCESS =
  'app/VoucherPurchasePage/GET_GIFTCARDS_SUCCESS';
export const GET_GIFTCARDS_ERROR =
  'app/VoucherPurchasePage/GET_GIFTCARDS_ERROR';

export const FETCH_LINE_ITEMS_SUCCESS =
  'app/VoucherPurchasePage/FETCH_LINE_ITEMS_SUCCESS';
export const FETCH_LINE_ITEMS_ERROR =
  'app/VoucherPurchasePage/FETCH_LINE_ITEMS_ERROR';

export const FETCH_LINE_ITEMS_REQUEST =
  'app/VoucherPurchasePage/FETCH_LINE_ITEMS_REQUEST';

  export const INITIATE_COUPON_TRANSACTION_SUCCESS =
  'app/VoucherPurchasePage/INITIATE_COUPON_TRANSACTION_SUCCESS';
export const INITIATE_COUPON_TRANSACTION_ERROR =
  'app/VoucherPurchasePage/INITIATE_COUPON_TRANSACTION_ERROR';

export const INITIATE_COUPON_TRANSACTION_REQUEST =
  'app/VoucherPurchasePage/INITIATE_COUPON_TRANSACTION_REQUEST';

import * as log from '../../util/log';
const { UUID } = sdkTypes;

export const purchaseVoucher = () => dispatch => {
  setTimeout(() => {
    dispatch({ type: PURCHASE_VOUCHER_SUCCESS });
  }, 1000);
};

const initialState = {
  selected: null,
  form: {
    recipientName: '',
    recipientEmail: '',
    senderName: '',
    message: '',
    acceptedTerms: false,
  },
  purchaseSuccess: false,
  pagination: null,
  searchParams: null,
  searchInProgress: false,
  getGiftCardsError: null,
  currentPageResultIds: [],
  fetchLineItemsInProgress: false,
   fetchLineItemsError: null,
};

const resultIds = data => {
  const listings = data.data;
  return listings
    .filter(l => !l.attributes.deleted && l.attributes.state !== 'draft')
    .map(l => l.id);
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_LINE_ITEMS_REQUEST:
      return {
        ...state,
        fetchLineItemsInProgress: true,
        fetchLineItemsError: null,
      };
    case FETCH_LINE_ITEMS_SUCCESS:
    
      return { ...state, fetchLineItemsInProgress: false, lineItems: payload };
    case INITIATE_COUPON_TRANSACTION_REQUEST:
      return {
        ...state
      };
    case INITIATE_COUPON_TRANSACTION_SUCCESS:
    
      return { ...state };
    case INITIATE_COUPON_TRANSACTION_ERROR:
      return {
        ...state,
      };
    case GET_GIFTCARDS_REQUEST:
      return {
        ...state,
        searchParams: payload.searchParams,
        searchInProgress: true,
        searchMapListingIds: [],
        getGiftCardsError: null,
      };
    case GET_GIFTCARDS_SUCCESS:
      return {
        ...state,
        currentPageResultIds: resultIds(payload.data),
        pagination: payload.data.meta,
        searchInProgress: false,
      };
    case GET_GIFTCARDS_ERROR:
      // eslint-disable-next-line no-console
      console.error(payload);
      return { ...state, searchInProgress: false, getGiftCardsError: payload };

    default:
      return state;
  }
}

export const getGiftCardsRequest = searchParams => ({
  type: GET_GIFTCARDS_REQUEST,
  payload: { searchParams },
});

export const getGiftCardsSuccess = response => ({
  type: GET_GIFTCARDS_SUCCESS,
  payload: { data: response.data },
});

export const getGiftCardsError = e => ({
  type: GET_GIFTCARDS_ERROR,
  error: true,
  payload: e,
});

export const getGiftCards = (searchParams, config) => (
  dispatch,
  getState,
  sdk
) => {
  dispatch(getGiftCardsRequest(searchParams));

  const {
    perPage,
    price,
    dates,
    seats,
    sort,
    mapSearch,
    listingTypePathParam,
    isListingTypeVariant,
    ...restOfParams
  } = searchParams;

  const params = {
    pub_listingType: ['gift-card'],
    perPage,
  };


  return sdk.listings
    .query(params)
    .then(response => {

      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };

      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(getGiftCardsSuccess(response));
      return response;
    })
    .catch(e => {
      const error = storableError(e);
      dispatch(getGiftCardsError(error));
      if (!(isErrorUserPendingApproval(error) || isForbiddenError(error))) {
        throw e;
      }
    });
};

export const fetchLineItemsRequest = () => ({ type: FETCH_LINE_ITEMS_REQUEST });
export const fetchLineItemsSuccess = lineItems => ({
  type: FETCH_LINE_ITEMS_SUCCESS,
  payload: lineItems,
});
export const fetchLineItemsError = error => ({
  type: FETCH_LINE_ITEMS_ERROR,
  error: true,
  payload: error,
});

export const fetchTransactionLineItems = ({
  orderData,
  listingId,
  isOwnListing,
}) => dispatch => {

  dispatch(fetchLineItemsRequest());
  transactionLineItems({ orderData, listingId, isOwnListing })
    .then(response => {

      const lineItems = response.data;
      dispatch(fetchLineItemsSuccess(lineItems));
    })
    .catch(e => {
    
      dispatch(fetchLineItemsError(storableError(e)));
      log.error(e, 'fetching-line-items-failed', {
        listingId: listingId.uuid,
        orderData,
      });
    });
};

export const loadData = (params, search, config) => dispatch => {
  const queryParams = parse(search, {
    latlng: ['origin'],
    latlngBounds: ['bounds'],
  });

  const { page = 1, address, origin, ...rest } = queryParams;

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  const getGiftCardsCall = getGiftCards(
    {
      // ...rest,
      // ...originMaybe,
      // ...listingTypeVariantMaybe,
      page,
      perPage: 25,
      include: ['author', 'author.profileImage', 'images'],
      'fields.listing': [
        'title',
        'price',
        'deleted',
        'state',
        'publicData.listingType',
        'publicData.transactionProcessAlias',
        'publicData.unitType',
        // These help rendering of 'purchase' listings,
        // when transitioning from search page to listing page
        'publicData.pickupEnabled',
        'publicData.shippingEnabled',
        'publicData.priceVariationsEnabled',
        'publicData.priceVariants',
      ],
      'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
      'fields.image': [
        'variants.scaled-small',
        'variants.scaled-medium',
        `variants.${variantPrefix}`,
        `variants.${variantPrefix}-2x`,
        'variants.square-small',
        'variants.square-small2x',
        'variants.square-xsmall',
        'variants.square-xsmall2x',
      ],
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      'limit.images': 1,
    },
    config
  );
  return dispatch(getGiftCardsCall);
};
